import React from 'react';
import _ from 'lodash';
import { createTableMultiSort } from 'react-virtualized';

import EncounterList from './EncounterList';
const Api = require('./Config');

const tagStyle = {
  color: 'white',
  borderRadius: 20,
  paddingLeft: 12,
  paddingRight: 12,
  paddingTop: 5,
  paddingBottom: 5,
};

export default class EncounterTCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      encounters: [],
      filters: {},
      startIdx: 0,
      endIdx: 10,
      maxRows: 999999,
      oldEncounterMaxId: null,
      newEncounterMaxId: null,
      queryAmount: 100,
      initEncounterCount: 0,
    };

    // Infinite Loader
    this.loadMore = this.loadMore.bind(this);
    this.getMoreHl7Reviews = this.getMoreHl7Reviews.bind(this);

    // Sort
    this.sort = this.sort.bind(this);
    this.sortState = createTableMultiSort(this.sort);
  }

  componentDidMount() {
    this.getHl7Reviews(true, {});
  }

  getHl7Reviews(init, newFilters) {
    if (this.state.endIdx > this.state.maxIdx) this.state.endIdx = this.state.maxIdx;
    const filters = { ...newFilters, t_code: this.props.t_code };

    Api.getHl7Reviews({
      p_from_date: null,
      p_till_date: null,
      startIdx: 0,
      queryAmount: this.state.queryAmount,
      filter: filters,
    })
      .then((data) => {
        // get the max id in the list
        const maxId = _.max(_.map(data.encounters, (a) => parseInt(a.id)));

        this.setState({
          encounters: data.encounters,
          oldEncounterMaxId: maxId,
          newEncounterMaxId: maxId,
          maxRows: data.no_of_rows,
          filters: filters,
          startIdx: 0,
        });

        if (init) {
          this.setState({ initEncounterCount: data.encounters.length });
        }
      })
      .catch((error) => {
        alert('Error getting encounters: ' + error);
      });
  }

  loadMore() {
    this.state.startIdx = this.state.queryAmount + this.state.startIdx;

    if (this.state.maxRows > this.state.startIdx)
      this.getMoreHl7Reviews({ startIndex: this.state.startIdx, queryAmount: this.state.queryAmount });
    else return;

    return new Promise((resolve, _reject) => {
      this.promiseResolve = resolve;
    });
  }

  getMoreHl7Reviews({ startIndex, queryAmount }) {
    console.log('Getting more encounters');

    if (this.state.endIdx > this.state.maxIdx) this.state.endIdx = this.state.maxIdx;
    const filters = { ...this.state.filters, t_code: this.props.t_code };

    Api.getHl7Reviews({
      p_from_date: null,
      p_till_date: null,
      startIdx: startIndex,
      queryAmount,
      filter: filters,
      maxFilter: {
        max_id: this.state.oldEncounterMaxId,
        is_new: false,
      },
    })
      .then((data) => {
        this.setState({
          encounters: this.state.encounters.concat(data.encounters),
        });
        this.promiseResolve();
      })
      .catch((error) => {
        console.log(error);
        alert('Error: ' + error);
      });
  }

  sort({ sortBy, sortDirection }) {
    const dirs = [];
    _.each(sortBy, (a) => {
      dirs.push(sortDirection[a].toLowerCase());
    });

    this.setState({ sortBy, sortDirection, encounters: _.orderBy(this.state.encounters, sortBy, dirs) });
  }

  render() {
    return (
      <div className="encounter-tcode">
        <div className="row" style={{ paddingTop: 20, paddingBottom: 20 }}>
          <div className="col-md-6">
            <h3 style={{ margin: 0 }}>{this.props.t_code}</h3>
            <div style={{ paddingTop: 15 }}>
              {this.props.data.deleted === 'Y' && (
                <span style={{ ...{ backgroundColor: '#8d0101' }, ...tagStyle }}>Archived</span>
              )}
              {this.props.data.deleted === 'N' && (
                <span style={{ ...{ backgroundColor: '#0e6b0e' }, ...tagStyle }}>Active</span>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <p>
              <strong>Journey Name:</strong> {this.props.data.journey_name}
            </p>
            <p>
              <strong>Group:</strong> {this.props.data.group_name}
            </p>
          </div>
        </div>
        {this.state.initEncounterCount > 0 && (
          <EncounterList
            encounters={this.state.encounters}
            allJourneyNames={this.props.allJourneyNames}
            allStatus={this.props.allStatus}
            allApps={this.props.allApps}
            maxRows={this.state.maxRows}
            loadMore={this.loadMore}
            listHeight={300}
            onNoteSave={(item) => {
              if (item) {
                const newEncounters = this.state.encounters.map((encItem) => {
                  if (encItem.PMHID === item.PMHID) {
                    encItem.note = item.note;
                  }
                  return encItem;
                });
                this.setState({ encounters: newEncounters });
                this.props.onNoteSave(item);
              }
            }}
            onESViewClick={this.props.onESViewClick}
            onMailClick={this.props.onMailClick}
            onStatusChange={(pmhid, status) => {
              const newEncounters = this.state.encounters.map((encItem) => {
                if (encItem.PMHID === pmhid) {
                  encItem.current_status = status;
                }
                return encItem;
              });
              this.setState({ encounters: newEncounters });
              this.props.onStatusChange(pmhid, status);
            }}
            onFilterChange={(item) => {
              this.getHl7Reviews(false, item);
            }}
            sortState={this.sortState}
            tableStyle={{ border: 'solid 1px', backgroundColor: 'rgb(234, 234, 234)' }}
            role={this.props.role}
          />
        )}
      </div>
    );
  }
}
